import { Outlet, createFileRoute } from '@tanstack/react-router';
import { CapabilityGate } from '@/components/billing/CapabilityGate';

function OrdersAreaLayout() {
	return (
		<CapabilityGate capability="sales">
			<Outlet />
		</CapabilityGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/orders')({
	component: OrdersAreaLayout,
});
